export default __webpack_public_path__ + "static/media/image-yx1-earphones.74e2f27b.jpg";